// NBL teal brand palette - single source of truth for JS/MUI consumers.
// Mirrors the --nbl-* CSS custom properties in src/styles/index.css exactly;
// keep both in sync if either changes.
export const nblColors = {
  dark: "#0d2f3d",
  mid: "#0f2739",
  primary: "#1a6b7c",
  light: "#2b93c8",
  accent: "#2dd4bf",
  hover: "#155e6e",
  tint: "#e6f7f8",
};

export default nblColors;
